export const extractLastBracketKey = ( str: string ) => {
  const match = str.match( /\[([^\]]+)\]$/ );
  return match ? match[ 1 ] : null;
};
